import React, { useState, useEffect, useRef } from 'react';
import './GetIntouch.css';
import { initFacebookPixel } from '../facebookPixel';
import Swal from 'sweetalert2';
import { areas } from '../Centers/areas';
const GetInTouch = () => {
  const [userName, setUserName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedCenter, setSelectedCenter] = useState('');
  const [message, setMessage] = useState('');
  const [centers, setCenters] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [email, setEmail] = useState('');
  const dropdownRef = useRef(null);  // Ref for the dropdown container
  const selectWrapperRef = useRef(null);  // Ref for the wrapper around the select element
  const [isFormValid, setIsFormValid] = useState(false);
  const [touchedFields, setTouchedFields] = useState({
    userName: false,
    contactNumber: false,
    selectedArea: false,
    email: false,
    message: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedArea: '',
    email: '',
    message: '', // Add message error handling
  });
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  const handleAreaSelect = (name) => {
    setSelectedArea(name);
    setShowDropdown(false);  // Close dropdown after selection
    // Clear error when area is selected
    setErrorMessages((prevErrors) => ({ ...prevErrors, selectedArea: '' }));
  };

  // Handle option selection for the center dropdown
  const handleOptionSelect = (name) => {
    setSelectedArea(name);
    setShowDropdown(false);  // Close dropdown after selection
    // Clear error when center is selected
    setErrorMessages((prevErrors) =>({ ...prevErrors, selectedArea: '' }));
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        selectWrapperRef.current &&
        !selectWrapperRef.current.contains(event.target)
      ) {
        setShowDropdown(false);  // Close dropdown if click is outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Validate form fields
  const validateForm = () => {
    let isValid = true;
    const errors = {
      userName: '',
      contactNumber: '',
      selectedArea: '',
      email: '',
    };

    if (!userName.trim()) {
      errors.userName = 'Name is required.';
      isValid = false;
    }

    if (!contactNumber.trim() || contactNumber.length !== 10) {
      errors.contactNumber = 'Please enter a valid 10-digit contact number.';
      isValid = false;
    }
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = 'Please enter a valid email address.';
      isValid = false;
    }

    if (!selectedArea) {
      errors.selectedArea = 'Please select an area.';
      isValid = false;
    }

    setErrorMessages(errors);
    setIsFormValid(isValid);
    return isValid;
  };



  // Handle input change and clear individual errors
  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setTouchedFields((prev) => ({ ...prev, [field]: true }));

    if (field === 'userName') {
      setUserName(value);
      if (value.trim()) {
        setErrorMessages((prevErrors) => ({ ...prevErrors, userName: '' }));
      }
    } else if (field === 'contactNumber') {
      setContactNumber(value);
      if (value.length === 10) {
        setErrorMessages((prevErrors) => ({ ...prevErrors, contactNumber: '' }));
      }
    } else if (field === 'email') {
      setEmail(value);
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) setErrorMessages((prevErrors) => ({ ...prevErrors, email: '' }));
    }else if (field === 'selectedArea') {
      setSelectedArea(value);
      if (value) {
        setErrorMessages((prevErrors) => ({ ...prevErrors, selectedArea: '' }));
      }
    } else if (field === 'message') {
      setMessage(value);
    }
  };

  useEffect(() => {
    validateForm(); // Ensure form is validated when the component mounts or data changes
  }, [userName, contactNumber, selectedArea, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields before proceeding
    if (validateForm()) {
      const bookingData = {
        parentsName: userName,
        mobileNumber: contactNumber,
        email,
        area: selectedArea, 
        qresponse: message,
        source: "Swimming-playing"
      };
      try {
        const apiUrl = process.env.REACT_APP_API_URL_GIT; // Get API URL from the environment variable
  const apiKey = process.env.REACT_APP_API_KEY; 


        // Send POST request to the API
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey, // Use the API key from the environment variable
          },
          body: JSON.stringify(bookingData),
        });

        if (response.ok) {
          const responseData = await response.json();

          // Set sessionStorage values first
          sessionStorage.setItem('paymentStatus', 'success');
          sessionStorage.setItem('message', 'One of our executives will reach out to you soon.\n\nThank you!');

          // Then redirect to the SuccessPage
          window.location.href = '/thankyou-page';
         
        } else {
          // Handle server-side error (e.g., 500 status)
          const errorData = await response.json();
        }
      } catch (error) {
      }
    }
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div id="booktrail" className="book-trial-container">
      <h2 className="form-title">GET IN TOUCH</h2>
      
      <form className="booking-form" onSubmit={handleSubmit}>
      <div class="enrollment-banner">
          Please Share your details, our team will reach out to you.
        </div>
        <div className="floating-select">
          <input
            className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
            type="text"
            value={userName}
            onChange={(e) => handleInputChange(e, 'userName')}
            placeholder="Name"
          />
          {userName && <label htmlFor="userName">Name</label>}
          {touchedFields.userName && errorMessages.userName && (
            <span className="error">{errorMessages.userName}</span>
          )}
        </div>
        <div className="floating-select">
          <input
            className={`sales-filter-academy ${email ? 'has-value' : ''}`}
            type="email"
            value={email}
            onChange={(e) => handleInputChange(e, 'email')}
            placeholder="Email"
          />
          {email && <label htmlFor="email">Email</label>}
          {touchedFields.email && errorMessages.email && (
            <span className="error">{errorMessages.email}</span>
          )}
        </div>

        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, '');
            }}
            maxLength={10}
            placeholder="Contact Number"
          />
          {contactNumber && <label htmlFor="contactNumber">Phone Number</label>}
          {touchedFields.contactNumber && errorMessages.contactNumber && (
            <span className="error">{errorMessages.contactNumber}</span>
          )}
        </div>

        <div className="floating-select" ref={selectWrapperRef}>
          <div
            className={`sales-filter-academy ${selectedArea ? 'has-value' : ''}`}
            onClick={() => setShowDropdown(!showDropdown)} // Toggle dropdown on click
          >
            <div className="selected-option">
              {selectedArea || 'Select Area'}
            </div>
            <div className={`custom-dropdown ${showDropdown ? 'open' : ''}`} ref={dropdownRef}>
              {areas.map((area) => (
                <div
                  key={area.name}
                  className="custom-option"
                  onClick={() => handleAreaSelect(area.name)}
                >
                  {area.name}
                </div>
              ))}
            </div>
          </div>
          {selectedArea && <label htmlFor="selectedArea">Area</label>}
          {touchedFields.selectedArea && errorMessages.selectedArea && (
            <span className="error">{errorMessages.selectedArea}</span>
          )}
        </div>


        <div className="floating-select-message">
          <textarea
            className={`sales-filter-academy ${message ? 'has-value' : ''}`}
            value={message}
            onChange={(e) => handleInputChange(e, 'message')}
            placeholder="Please Enter your Query (Optional)"
          />
          {message && <label htmlFor="message">Message</label>}
          {touchedFields.message && errorMessages.message && (
            <span className="error">{errorMessages.message}</span>
          )}
        </div>

        <div className="form-group">
          <button className="form-button" type="submit" disabled={!isFormValid}>Submit</button>

        </div>
      </form>
    </div>
  );
};

export default GetInTouch;